import React, { useMemo } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type ConfettiProps = {
  pieceCount?: number;
  originY?: string;
};
const palette = ['#4BE4FF', '#A6B6F8', '#5B5299', '#FFFFFF'];
type Piece = {
  id: number;
  color: string;
  angle: number;
  distance: number;
  delay: number;
  duration: number;
  rotate: number;
  width: number;
  height: number;
  round: boolean;
  fall: number;
};
function createPieces(count: number): Piece[] {
  return Array.from({
    length: count
  }, (_, index) => {
    const spread = (index * 9301 + 49297) % 233280 / 233280;
    const alt = (index * 4523 + 7919) % 997 / 997;
    const angle = index / count * Math.PI * 2 + spread * 0.35;
    return {
      id: index,
      color: palette[index % palette.length],
      angle,
      distance: 120 + alt * 130,
      delay: spread * 0.08,
      duration: 0.85 + alt * 0.5,
      rotate: 160 + alt * 420,
      width: alt > 0.7 ? 6 : 8,
      height: alt > 0.7 ? 6 : 12,
      round: alt > 0.7,
      fall: 30 + spread * 70
    };
  });
}
export function Confetti({
  pieceCount = 34,
  originY = '38%'
}: ConfettiProps) {
  const shouldReduceMotion = useReducedMotion();
  const pieces = useMemo(() => createPieces(pieceCount), [pieceCount]);
  if (shouldReduceMotion) return null;
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-59" data-mp="21lvcqqdria3w">
      {pieces.map(piece => {
      const endX = Math.cos(piece.angle) * piece.distance;
      const endY = Math.sin(piece.angle) * piece.distance * 0.72;
      return <motion.span key={piece.id} initial={{
        opacity: 0,
        x: 0,
        y: 0,
        scale: 0.4,
        rotate: 0
      }} animate={{
        opacity: [0, 1, 1, 0],
        x: [0, endX * 0.6, endX * 0.9, endX],
        y: [0, endY * 0.6, endY, endY + piece.fall],
        scale: [0.4, 1, 1, 0.9],
        rotate: [0, piece.rotate * 0.5, piece.rotate * 0.85, piece.rotate]
      }} transition={{
        duration: piece.duration,
        delay: piece.delay,
        ease: [0.16, 0.9, 0.35, 1],
        times: [0, 0.28, 0.75, 1]
      }} style={{
        left: '50%',
        top: originY,
        width: piece.width,
        height: piece.height,
        backgroundColor: piece.color,
        borderRadius: piece.round ? '9999px' : '2px'
      }} className="absolute block" data-id="element-60" data-mp="1dnwgm3h805mb" />;
    })}
    </div>;
}